import React, { type PropsWithChildren } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';
import Animated, { FadeIn } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemFloatingActions = (props: PropsWithChildren) => {
  const { children } = props;

  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // ─── Styles ──────────────────────────────────────────────────────────

  const safeAreaStyles = useStyle(
    () => ({ paddingBottom: Math.max(safeAreaBottomInset, theme.spacing['6']) }),
    [safeAreaBottomInset],
  );
  const containerStyles = [styles.container, safeAreaStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Animated.View
      entering={FadeIn.duration(theme.transitions.base).delay(650)}
      pointerEvents="box-none"
      style={styles.outerContainer}
    >
      <LinearGradient
        colors={GRADIENT_COLORS}
        end={GRADIENT_END}
        locations={GRADIENT_LOCATIONS}
        pointerEvents="box-none"
        start={GRADIENT_START}
        style={containerStyles}
      >
        {children}
      </LinearGradient>
    </Animated.View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS = [
  'rgba(248, 247, 240, 0)',
  'rgba(248, 247, 240, 0.82)',
  'rgba(248, 247, 240, 0.9)',
] as const;
const GRADIENT_LOCATIONS = [0, 0.6, 1] as const;
const GRADIENT_START = { x: 0, y: 0 } as const;
const GRADIENT_END = { x: 0, y: 1 } as const;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['3'],
    paddingTop: theme.spacing['20'],
    paddingHorizontal: theme.spacing['6'],
  },
});
